
export function Loader({isLoading}) {
    return (
        <div className='loader'>
            {isLoading ? 
            <div className="loading-spinner">
            </div>
            : 
            <div className="loading-spinner-inactive">
                
            </div>}
        </div>
    );

}